import { useState } from 'react';

export const useEmailValidation = () => {
  const [emailError, setEmailError] = useState('');
  const [hasShownEmailError, setHasShownEmailError] = useState(false);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isCardPaymentEnabled = (donationType, donorEmail) => {
    if (donationType === 'monthly') {
      return donorEmail && validateEmail(donorEmail);
    }
    return true;
  };

  const showEmailValidationError = (donationType, donorEmail) => {
    if (donationType === 'monthly' && (!donorEmail || !validateEmail(donorEmail))) {
      setHasShownEmailError(true);
      if (!donorEmail) {
        setEmailError('Please enter your email address to continue');
      } else {
        setEmailError('Please enter a valid email address');
      }
    }
  };

  const handleEmailChange = (e, setDonorEmail) => {
    const email = e.target.value;
    setDonorEmail(email);
    if (emailError) {
      setEmailError('');
    }
  };

  const clearEmailValidation = () => {
    setEmailError('');
    setHasShownEmailError(false);
  };

  return {
    emailError,
    hasShownEmailError,
    validateEmail,
    isCardPaymentEnabled,
    showEmailValidationError,
    handleEmailChange,
    clearEmailValidation,
    setEmailError,
    setHasShownEmailError,
  };
};
